module.exports = __webpack_public_path__ + "static/media/hex-bg.05d17453.png";